import React, { useContext, useEffect, forwardRef } from 'react';
import { useTranslation } from '@/app/i18n/client';
import languageContext from '@/context/language';
import { useMutationReorder } from '@/hooks/orderhistory.hook';
import { useRouter } from 'next/navigation';
import { useEventTracking } from '@/shared/tracking/use-tracking';
import { OrderItem } from '@/types/order';
import { SpinnerBox } from '@/shared/pageComponents/spinner-box';
import { GlobalLoading } from '@/shared/components';

interface Product {
  product: OrderItem;
  pageType: string;
}
export const Reorder = forwardRef<HTMLInputElement, Product>(function Reorder(props, ref) {
  const { lang } = useContext(languageContext);
  const { t } = useTranslation(lang, 'orderhistory');
  const { product, pageType } = props;
  const { mutate, isLoading: reorderLoading, isSuccess } = useMutationReorder();
  const router = useRouter();
  const { trackEvent } = useEventTracking();

  const reorder = (item: OrderItem) => {
    trackEvent({
      key: 'cart',
      action: 'addToCart',
      payload: {
        products: {
          name: item?.catalogName,
          catalogId: item?.catalogNumber,
          quantity: item?.quantity,
          price: item?.itemSubTotal,
          uom: item?.unitSize,
          placement: pageType,
          method: 'reorder',
        },
      },
    });
    mutate([{ catalogNumber: item.catalogNumber, quantity: item.quantity }]);
  };

  useEffect(() => {
    if (isSuccess) {
      if (window.miniCart?.setCurrentQuantity) {
        window.miniCart?.setCurrentQuantity();
      }
      GlobalLoading.show();
      router.push('/cart');
    }
  }, [isSuccess]);

  return (
    <SpinnerBox isLoading={reorderLoading}>
      <div
        className="print:hidden border border-solid border-gray-300 w-max px-4 py-1 rounded-2xl mr-4 font-normal text-xs cursor-pointer"
        onClick={() => reorder(product)}
      >
        {t('reorder')}
      </div>
    </SpinnerBox>
  );
});
